import React from 'react'
import Button from 'devextreme-react/button'

interface NavigationItem {
	model: string
	text: string
	desc?: string
	filter?: string
	dashboard?: boolean
	folder?: string
}

interface FavoriteButtonProps {
	item: NavigationItem
	isFavorite: boolean
	onToggle: (item: NavigationItem, e: any) => void
}

export default function FavoriteButton({ item, isFavorite, onToggle }: FavoriteButtonProps) {
	return (
		<Button
			icon="bookmark"
			hint={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
			style={{
				position: 'absolute',
				top: '10px',
				right: '10px',
				backgroundColor: isFavorite ? '#ff794e' : '#ffffff',
				border: '1px solid #ddd',
				color: isFavorite ? 'red' : '#000000',
				borderRadius: '50%',
				boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
				zIndex: 10,
			}}
			onClick={e => onToggle(item, e)}
		/>
	)
}
